import api from "PFCore/api";

export type DownloadAttachmentPayload = {
  id: number;
};

type DownloadAttachmentResponse = {
  fileUrl: string;
};

export const downloadAttachment = ({ id }: DownloadAttachmentPayload): Promise<DownloadAttachmentResponse> =>
  api({
    url: `attachments/${id}/download`
  });
